import { createSelector } from 'reselect';
import { RootState } from '..';
import { calculateDistanceInMeters } from '../../utils';
import { getCurrentUserLocation } from '../user/selector';
import { MealWithDistance } from './types';

const _getMealState = ({ mealReducers }: RootState) => mealReducers;
export const getMealState = createSelector(_getMealState, state => state);
export const getMeals = createSelector(_getMealState, state => state.meals);

export const sortedMealsByDistance = createSelector(
  [getMeals, getCurrentUserLocation],
  (meals, currentLocation) => {
    return meals
      .reduce((result: MealWithDistance[], current) => {
        const distance = calculateDistanceInMeters(
          current.cookDetails?.location,
          currentLocation
        );
        return [...result, { ...current, distance }];
      }, [])
      .sort((a, b) => a.distance - b.distance);
  }
);
